import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetCustomersResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "customers": [
                    {
                        "business_name": 2,
                        "number": 2,
                        "fantasy_name": "Customer",
                        "code": "01234"
                    },
                    {
                        "business_name": 3,
                        "number": 3,
                        "fantasy_name": "Invalid Customer",
                        "code": "01235"
                    },
                ]
            },
            errors: []
        }
    }

    customers() {
        return this.content().customers.map(customer => {
            return {
                taxpayerIdentificationNumber: customer.taxpayer_identification_number,
                code: customer.code,
                businessName: customer.business_name,
                fantasyName: customer.fantasy_name,
            }
        });
    }
}